import React from "react";

const Error = ({ message }) => {
   return (
      <p className="error-message">{message}</p>
   )
}

export default Error